import React, { useEffect } from 'react';
import { OLE_LOGO_SRC } from './assets/oleLogo';
import { usePortalCopy, usePortalUi } from './PortalUi';
import { PortalModals } from './modals/PortalModals';
import { PORTAL_FIXTURE } from './mock/portalFixture';
import { getPortalLegalLinks } from './legalLinks';
import './clientPortal.css';

export function ClientPortalShell({ children }: { children: React.ReactNode }) {
  const t = usePortalCopy();
  const { toast } = usePortalUi();
  const legalLinks = getPortalLegalLinks();

  /* Sin gate, todo `/status/*` termina en el tablero: un solo título. */
  useEffect(() => {
    const previous = document.title;
    document.title = t('titleBoard');
    return () => {
      document.title = previous;
    };
  }, [t]);

  return (
    <div className="cp-root">
      <div className="stage">
        <div className="topbar">
          {/* OUW-106: no EN|ES toggle. ?lang= remains a hidden override. */}
          <img className="logo" src={OLE_LOGO_SRC} alt={t('logoAlt')} />
        </div>
        {children}
        <footer className="pg">
          <div>
            <p className="contact" data-spec="contact">
              {t('footerQuestions')}{' '}
              <a href={`mailto:${PORTAL_FIXTURE.supportEmail}`}>{PORTAL_FIXTURE.supportEmail}</a>
            </p>
            <p>{t('footerLegal')}</p>
          </div>
          <div className="legal" data-spec="legal">
            {legalLinks.map(({ key, href }) => (
              <a key={key} href={href} target="_blank" rel="noopener noreferrer">
                {t(key)}
              </a>
            ))}
          </div>
        </footer>
      </div>
      <PortalModals />
      <div className={`toast${toast ? ' on' : ''}`} role="status">{toast}</div>
    </div>
  );
}
